module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fd-body"
  }, [_c('div', {
    staticClass: "fd-b-airport d-flex justify-space-between align-start"
  }, [_c('div', [_vm._v("\n      " + _vm._s(_vm.legSelected[_vm.flight][0].origin.AirportName) + " (" + _vm._s(_vm.legSelected[_vm.flight][0].origin.AirportCode) + ")\n      "), _c('i', {
    staticClass: "fas fa-plane"
  }), _vm._v("\n      " + _vm._s(_vm.legSelected[_vm.flight][_vm.legSelected[_vm.flight].length - 1].destination.AirportName) + " (" + _vm._s(_vm.legSelected[_vm.flight][_vm.legSelected[_vm.flight].length - 1].destination.AirportCode) + ")\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "change-flight",
    on: {
      "click": function($event) {
        _vm.backLegSelect('leg1')
      }
    }
  }, [_vm._v("Change flight")])]), _vm._v(" "), _c('div', {
    staticClass: "fd-cabin-class d-flex"
  }, [_c('span', [_vm._v("Cabin Class:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cabinLabel(_vm.legSelected.cabin)))])]), _vm._v(" "), _c('div', {
    staticClass: "fd-b-airline d-flex align-start"
  }, [_c('img', {
    attrs: {
      "src": _vm.legSelected[_vm.flight][0].logo
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.legSelected.flightName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(_vm.legSelected[_vm.flight][0].origin.DateTime)))]), _vm._v(" "), _c('div', {
    staticClass: "fd-b-time"
  }, [_vm._v("\n        " + _vm._s(_vm.timeFormat(_vm.legSelected[_vm.flight][0].origin.DateTime)) + "\n        -\n        " + _vm._s(_vm.timeFormat(_vm.legSelected[_vm.flight][_vm.legSelected[_vm.flight].length - 1].destination.DateTime)) + "\n        (" + _vm._s(_vm.timeDiff(_vm.legSelected[_vm.flight][0].origin.DateTime, _vm.legSelected[_vm.flight][_vm.legSelected[_vm.flight].length - 1].destination.DateTime)) + ", " + _vm._s(_vm.countStop(_vm.legSelected[_vm.flight])) + ")\n      ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1399d5f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1399d5f2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DItinerary/FlightDetailsBox.vue
// module id = 2039
// module chunks = 0